import React from 'react';
import { connect as connectWrapper } from '@atlassian/jira-react-redux';
import { SectionContext } from './context';
import withNamespacedId from './namespaced-id';
import type { State, Props, SectionContainerProps } from './types';
import { storeKey } from './util';

function SectionsContainer({
	id,
	width,
	style,
	dispatch,
	linkToParent,
	...otherProps
}: SectionContainerProps) {
	const finalStyle = {
		...style,
		width,
	};
	// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
	return <div {...otherProps} style={finalStyle} />;
}

const mapStateToProps = (state: State, { id, width }: Props) => {
	const sectionState = state.sections[id] || {};
	const { widths = {} } = sectionState;
	const sectionsWidth = Object.keys(widths).reduce((acc, key) => acc + widths[key], 0);

	return {
		width: width ?? sectionsWidth,
	};
};

const connect = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	mapStateToPropsFn: any,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	mapDispatchToProps: any,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	mergeProps: any = undefined,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	options: any = {},
) =>
	connectWrapper(mapStateToPropsFn, mapDispatchToProps, mergeProps, {
		...options,
		context: SectionContext,
		storeKey,
	});

// The named export is used by the ColumnTexts component. Did you notice that this export is not wrapped by namespacedId HOC?
// That's because the consumer, ColumnTexts component, uses namespacedId HOC to enhance the IDs and wrapping it here will double namespace the IDs and that's something we don't want to do.
export const Container = connect(mapStateToProps, null, null, { storeKey })(SectionsContainer);

// The default export enhances the Container component with namespaced IDs. This export is used within the Portfolio application.
export default withNamespacedId(Container);
